import Open from './Open';
export default Open;
